// The analyser's floor and ceiling in dB: quieter reads as still, louder as a full bar
const FLOOR_DB = -85;
const CEILING_DB = -25;

// The low bands in the middle and the highs out at the edges, so the bars swell from the center
const BAR_ORDER = [3, 1, 0, 2, 4];

// How tall each bar stands on a count-in click, the middle tallest
const CLICK_SHAPE = [0.5, 0.75, 1, 0.75, 0.5];

// A click's share left after each frame, so it dies away in about a third of a second
export const CLICK_DECAY = 0.86;

/** How strong a count-in click strikes the bars: the downbeat full, the others less. */
export const clickStrength = (countInBeat) => (countInBeat === 1 ? 1 : countInBeat > 1 ? 0.7 : 0);

/**
 * The bars' heights, 0..1, from an FFT in dB and a count-in click dying away. The bins are grouped
 * on a log scale, as the ear hears pitch, so the bass doesn't take every bar but the first.
 *
 * @param {Float32Array|number[]|null} spectrum - The analyser's bins in dB, low to high, or null for none
 * @param {number} click - What is left of the last count-in click, 0..1
 */
export const getWaveLevels = (spectrum, click = 0) => {
  const bars = BAR_ORDER.length;
  const bands = Array(bars).fill(0);

  if (spectrum && spectrum.length > 1) {
    for (let band = 0; band < bars; band += 1) {
      const from = Math.floor(spectrum.length ** (band / bars));
      const to = Math.max(from + 1, Math.floor(spectrum.length ** ((band + 1) / bars)));
      let sum = 0;

      for (let bin = from; bin < to; bin += 1) sum += Math.max(spectrum[bin], FLOOR_DB);

      const db = sum / (to - from);
      bands[band] = Math.min(1, Math.max(0, (db - FLOOR_DB) / (CEILING_DB - FLOOR_DB)));
    }
  }

  return BAR_ORDER.map((band, i) => Math.max(bands[band], click * CLICK_SHAPE[i]));
};
